import { z } from 'zod'
import { schedulerCronPattern } from '../scheduler'

export const adminSettingsFields = z.object({
  schedule: schedulerCronPattern,
  bcc: z.array(z.string().email()),
})
